import { Form } from 'react-router';

import { cn } from '~/styles/extended-theme';

import { PublicSearchInput } from '../search/public-search-input';

import { AppInfoCard } from './app-info-card';

export function HeaderSection({
  comboboxItems,
  eventComboboxItems,
  searchParams,
}: {
  comboboxItems: string[];
  eventComboboxItems: string[];
  searchParams: URLSearchParams;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 overflow-hidden pb-2 pt-12 desktop:flex-row">
      <div
        className={cn(
          'flex flex-col',
          'w-[361px] min-w-[361px]',
          'tablet:w-[596px] tablet:min-w-[596px]',
          'desktop:ml-[125px] desktop:w-[508px] desktop:min-w-[508px] desktop:max-[1600px]:ml-[325px]',
        )}
      >
        <p className="mb-4 font-mono text-h1 tracking-[1.5px]">
          Grow your gym.
          <br />
          Train anywhere.
        </p>
        <p className="mb-4 text-body1">
          Fighters Passport helps martial arts gyms get discovered by traveling athletes and gives
          athletes access to the best gyms to train wherever they go.
        </p>
        <div className="mb-4 flex rounded-2xl border border-gray-400">
          <AppInfoCard isAthleteSection={false} hasRightBorder />
          <AppInfoCard isAthleteSection />
        </div>
        <div className="flex flex-col gap-3 rounded-2xl bg-secondary/4 p-5 text-center">
          <p className="text-h6">Search for gyms and events near you!</p>
          <p className="text-subtitle1">Find Gyms & Classes</p>
          <Form>
            <PublicSearchInput
              comboboxItems={comboboxItems}
              searchParams={searchParams}
              namePlaceholder="Gym Name"
            />
            <button type="submit" className="hidden">
              {/* this is only here to make the form submit when the user presses enter */}
            </button>
          </Form>
          <p className="text-subtitle1">
            <span className="text-secondary">NEW!</span> Find Events
          </p>
          <Form action="/events" method="get">
            <PublicSearchInput
              comboboxItems={eventComboboxItems}
              searchParams={searchParams}
              namePlaceholder="Event Name"
            />
            <button type="submit" className="hidden">
              {/* this is only here to make the form submit when the user presses enter */}
            </button>
          </Form>
        </div>
      </div>
      <img
        className={cn(
          'ml-[75px]',
          'h-[269px] w-[459px] min-w-[459px]',
          'tablet:ml-[165px] tablet:h-[484px] tablet:w-[824px] tablet:min-w-[824px]',
          'desktop:ml-0',
        )}
        src="/img/masthead.png"
        alt="Masthead"
      />
    </div>
  );
}
